import Vue from "vue";

import store from "./store";

import axios from "axios";
axios.defaults.headers.common["X-CSRF-TOKEN"] = document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute("content");
axios.defaults.baseURL = document.head
    .querySelector('meta[name="api-base-url"]')
    .getAttribute("content");

import { bugsnagClient } from "./bootstrap";
bugsnagClient.getPlugin('vue').installVueErrorHandler(Vue)

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

// Core components
import ErrorList from "./components/ErrorList.vue";
import EmailSignup from "./components/EmailSignup.vue";
import BlogRow from "./components/BlogRow.vue";
import BlogListing from "./components/BlogListing.vue";
import ProductRow from "./components/product/ProductRow.vue";
import ProductList from "./components/product/ProductList.vue";
import ProductAlternatives from "./components/product/ProductAlternatives.vue";
import Search from "./components/search/Search.vue";
import ModalBtn from "./components/ModalBtn";
import EmailCartModal from "./components/EmailCartModal";

import Wishlist from "./components/account/Wishlist.vue";
import AddressListing from "./components/account/AddressListing";
import OrderListing from "./components/account/OrderListing";
import AddressModal from "./components/account/AddressModal";
import ChangePasswordModal from "./components/account/ChangePasswordModal";
import { Btn, Modal } from "uiv";
import BlogItem from "./components/BlogItem"

export const app = new Vue({
    el: "#app",

    components: {
        // CORE
        "error-list": ErrorList,
        "email-signup": EmailSignup,
        "blog-row": BlogRow,
        "blog-listing": BlogListing,
        "blog-item": BlogItem,
        "product-row": ProductRow,
        "product-list": ProductList,
        "product-alternatives": ProductAlternatives,
        search: Search,
        "modal-btn": ModalBtn,
        "email-cart-modal": EmailCartModal,

        wishlist: Wishlist,
        "order-listing": OrderListing,
        "address-listing": AddressListing,
        "address-modal": AddressModal,
        "change-password-modal": ChangePasswordModal,
        // UIV
        btn: Btn,
        modal: Modal
    },

    store,

    mounted() {
        const self = this;
        this.$nextTick(function() {
            window.jrConfig["vue"] = self;
        });
    }
});
